export default "__VITE_ASSET__BDv38F1j__"